module.exports = __webpack_public_path__ + "img/GNHandLogoSVGTransparent2.5aec65ac.svg";